// Saves a PNG data URL as "{name}.png".
export const downloadImage = (dataUrl: string, name: string): void => {
  const link = document.createElement('a')
  link.href = dataUrl
  link.download = `${name}.png`
  link.click()
}
